import { useState } from "react";
import { Plus, Receipt, FileUp, Wallet, MessageSquareHeart, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Separator } from "@/components/ui/separator";

interface DashboardFabProps {
  onNewTransaction: () => void;
  onImportStatement: () => void;
  onAddAccount: () => void;
  onFeedback?: () => void;
  importLocked?: boolean;
  accountLocked?: boolean;
}

export function DashboardFab({
  onNewTransaction,
  onImportStatement,
  onAddAccount,
  onFeedback,
  importLocked = false,
  accountLocked = false,
}: DashboardFabProps) {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 md:hidden z-50">
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button
            size="icon"
            className="h-14 w-14 rounded-full shadow-lg bg-primary hover:bg-primary/90"
          >
            <Plus className={`h-6 w-6 transition-transform ${open ? "rotate-45" : ""}`} />
          </Button>
        </PopoverTrigger>
        <PopoverContent
          side="top"
          align="end"
          className="w-48 p-2"
          sideOffset={8}
        >
          <div className="flex flex-col gap-1">
            <Button
              variant="ghost"
              className="justify-start h-10"
              onClick={() => {
                setOpen(false);
                onNewTransaction();
              }}
            >
              <Receipt className="h-4 w-4 mr-3" />
              Nova Transacao
            </Button>
            <Button
              variant="ghost"
              className="justify-start h-10"
              onClick={() => {
                setOpen(false);
                onImportStatement();
              }}
            >
              {importLocked ? (
                <Lock className="h-4 w-4 mr-3 text-muted-foreground" />
              ) : (
                <FileUp className="h-4 w-4 mr-3" />
              )}
              Importar Extrato
            </Button>
            <Button
              variant="ghost"
              className="justify-start h-10"
              onClick={() => {
                setOpen(false);
                onAddAccount();
              }}
            >
              {accountLocked ? (
                <Lock className="h-4 w-4 mr-3 text-muted-foreground" />
              ) : (
                <Wallet className="h-4 w-4 mr-3" />
              )}
              Adicionar Conta
            </Button>
            {onFeedback && (
              <>
                <Separator className="my-1" />
                <Button
                  variant="ghost"
                  className="justify-start h-10"
                  onClick={() => {
                    setOpen(false);
                    onFeedback();
                  }}
                >
                  <MessageSquareHeart className="h-4 w-4 mr-3" />
                  Enviar Feedback
                </Button>
              </>
            )}
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
}
